import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { User } from '../models/users';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CommonModule, RouterLink, TranslatePipe]
})
export class HeaderComponent {

  loginStatus$: Observable<User | null>;
  isAdmin$: Observable<boolean>;

  constructor(
    public authService: AuthService, 
    private router: Router
  ) {
    this.loginStatus$ = this.authService.user$;
    this.isAdmin$ = this.authService.isAdmin$;

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.closeNavbar();
    });
  }

  public closeNavbar() {
    const el = document.getElementById('navbarSupportedContent');
    if (el && el.classList.contains('show')) {
      el.classList.remove('show');
    }
  }

  public logout() {
    this.closeNavbar();
    this.authService.logout();
  }

}
